import React, { useState, useEffect } from 'react';
import { Clock, RefreshCw, RotateCcw } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const OrderHistory = ({ customerId, tableId, sessionId, onReorder }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchHistory = async () => {
    if (!customerId) return;
    setLoading(true);
    try {
      const res = await axios.get(`${API}/customers/${customerId}/orders`);
      setOrders(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchHistory(); }, [customerId]);

  const reorder = async (orderId) => {
    try {
      await axios.post(`${API}/orders/reorder?order_id=${orderId}&table_id=${tableId}&session_id=${sessionId}`);
      if (onReorder) onReorder();
    } catch (e) { alert('Erreur lors de la re-commande'); }
  };

  if (!customerId || orders.length === 0) return null;

  const formatDate = (d) => {
    if (!d) return '';
    try { return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' }); }
    catch { return d; }
  };

  const formatPrice = (p) => `${Math.round(p)}B`;

  return (
    <section className="px-4 mb-6" data-testid="order-history">
      <h2 className="text-base font-bold text-[#D4A853] mb-3 flex items-center gap-2">
        <Clock className="w-4 h-4" /> Mes commandes precedentes
      </h2>
      <div className="flex gap-3 overflow-x-auto no-scrollbar pb-2">
        {orders.slice(0, 5).map(order => (
          <div key={order.id} className="w-48 flex-shrink-0 bg-[#1A1A1A] rounded-2xl p-3 border border-[#333]"
            data-testid={`history-order-${order.id}`}>
            <div className="flex justify-between items-center mb-2">
              <span className="text-xs text-[#A0A0A0]">{formatDate(order.created_at)}</span>
              <span className="text-sm font-bold text-[#D4A853]">{formatPrice(order.total)}</span>
            </div>
            <div className="space-y-0.5 mb-2">
              {order.items?.slice(0, 3).map((item, i) => (
                <p key={i} className="text-xs text-[#ccc] truncate">{item.quantity}x {item.name}</p>
              ))}
              {order.items?.length > 3 && <p className="text-xs text-[#666]">+{order.items.length - 3} autres</p>}
            </div>
            <Button onClick={() => reorder(order.id)} size="sm"
              className="w-full bg-[#D4A853] hover:bg-[#C4983F] text-black rounded-full text-xs h-7"
              data-testid={`reorder-${order.id}`}>
              <RotateCcw className="w-3 h-3 mr-1" /> Recommander
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OrderHistory;
